import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput' 

import ActionGetSpv from '../../store/action/Supervisor/FetchAll'
import ActionGetAllUser from '../../store/action/Account/FetchAll'
import ActionAdd from '../../store/action/HelpdeskCs/Add'
import ActionEdit from '../../store/action/HelpdeskCs/Edit'

import {IsEdit, IsCreate, IsView } from '../../store/constants'

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'cs-id':'',
        'spv-id' : '',
        'cs-name' : '',
        'username' : '',
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.renderFormName = this.renderFormName.bind(this);
  }

  componentDidMount(){
    this.props.actionGetSpv();
    this.props.actionGetAllUser();
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    if(field === 'username'){
      formVal = formVal.set('cs-name',label); 
    }
    this.setState({ form:formVal })
  }
  handleSelectChange(field, value){
    if(value == null){
    // eslint-disable-next-line no-restricted-globals
      value = event.target.value;
    }
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    this.setState({ form:formVal })
  }
  async handleSubmit(dispatch) {
    const {form} = this.state;
    var isValid = true;
    const mandatoryField = fromJS(['spv-id', 'username', 'cs-name'])
    
    var newErrors = fromJS({});
    mandatoryField.map((field) => {
        if(form.get(field) === ''){
          isValid = false;
          newErrors = newErrors.set(field)
        }
    })

    this.setState({ errors: newErrors })

    if(!isValid){
      toast.error("Mandatory Field Cannot Empty!",toast.POSITION.TOP_RIGHT)
    }

    if(isValid){

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        case IsEdit:
            await this.SubmitEditData();
          break;
        default:
          // code blocks
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'data' : 
            {
                'spv-id' : form.get('spv-id'),
                'cs-name' : form.get('cs-name'),
                'username' : form.get('username'),
            }
        };

        var response = await this.props.actionAdd(data);
        if(response.ok){
          toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
          //toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
        }
  }

  async SubmitEditData(){
    const form = this.state.form;
    var data = 
        {
          'data' : {
                'cs-id': form.get('cs-id'),
                'spv-id': form.get('spv-id'),
                'cs-name': form.get('cs-name'),
                'username': form.get('username'),
            }
        };

        var response = await this.props.actionEdit(data);
        if(response.ok){
          toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true); 
        }else{
         // toast.error('Edit Failed', toast.POSITION.TOP_RIGHT); 
        }
  }

  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
        this.setState({
          form:  fromJS({
            'cs-id': this.props.item.get('cs-id'),
            'spv-id' : this.props.item.get('spv-id'), 
            'cs-name' : this.props.item.get('cs-name'),
            'username' : this.props.item.get('username'),
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })  
      }
    }
  }

  render(){
    const { form, errors, disabled } = this.state;
    let disabledOnEdit = disabled
    if(this.props.actionType === IsEdit){
      disabledOnEdit = true
    }

    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
          <span className="col-sm-2">SPV *</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='spv-id'
                    value={form.get('spv-id')}
                    options={fromJS({
                        'source': this.props.supervisorsall,
                        'value': 'spv-id',
                        'label': 'spv-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value, label)}
                    placeholder="SPV"
                    disabled={disabledOnEdit}
                    hasError={errors.has('spv-id')}
                />  
              </div>
          </div>
          <div className="row no-margin-bottom">
          <span className="col-sm-2">User *</span>
          <div className="col-sm-10">
                  <ComboboxInput
                    field='username'
                    value={form.get('username')}
                    options={fromJS({
                        'source': this.props.userall,
                        'value': 'username',
                        'label': 'full-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="User"
                    disabled={disabledOnEdit}
                    hasError={errors.has('username')}
                />  
              </div>
          </div>

          {this.renderFormName(form, errors)}

          <div className="row no-margin-bottom">
            <span className="col-sm-2"> &nbsp;</span>
            <div className="col-sm-6">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button"
                  className="btn btn-wide btn-primary"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFormName(form, errors){
    if(this.props.actionType === IsEdit){
      return(
        <div className="row no-margin-bottom">
            <span className="col-sm-2">New Name</span>
            <div className="col-sm-10">
                <TextInputField className="form-control"
                    field={'cs-name'}
                    value={ form.get('cs-name')}
                    onChange={(field, value) => this.handleChange(field,value)}
                    placeholder="name"
                    hasError={errors.has('name')}
                />
            </div>
        </div>
      )
    }
  }
}


export default connect(
  (state) => {
      return {
        supervisorsall: state.user.supervisorsall,
        userall: state.user.userall,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionEdit: ActionEdit,
      actionGetSpv: ActionGetSpv,
      actionGetAllUser: ActionGetAllUser,
  }, dispatch),
)(Form);